/**
 * External-drag ghost — the snapped drop preview for shelf/template payloads
 * hovering the grid, plus the post-drop "settling" placeholder that bridges
 * the gap until the receive's optimistic event renders. Pure overlay driven
 * by the interaction store: hovering re-renders exactly this component.
 */
import React from "react";
import { MCGridConfig, MCInteractionState } from "../model/types";
import { minutesToTime, yForMin } from "../model/gridGeometry";
import { MiniStore, useMiniSelector } from "../model/miniStore";
import { slotTherapyList } from "../../../helpers/slotTherapy";

interface ExternalDragOverlayProps {
  cfg: MCGridConfig;
  store: MiniStore<MCInteractionState>;
}

const ExternalDragOverlay: React.FC<ExternalDragOverlayProps> = ({ cfg, store }) => {
  const external = useMiniSelector(store, (s) => s.external);
  if (!external) return null;

  const top = yForMin(cfg, external.startMin);
  const height = Math.max(yForMin(cfg, external.endMin) - top - 1, cfg.slotHeightPx - 1);
  const abbrevs = slotTherapyList(external.payload.timeSlots, " + ");
  const label = external.payload.title || abbrevs || "Termin";

  return (
    <div
      className={[
        "mc-ghost",
        "mc-ghost--external",
        external.valid ? "" : "is-invalid",
        external.settling ? "is-settling" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      style={{
        left: `calc(var(--mc-col-w) * ${external.resourceIndex} + 1px)`,
        width: "calc(var(--mc-col-w) - 3px)",
        top,
        height,
      }}
    >
      <span className="mc-ghost-time">
        {minutesToTime(external.startMin)} {label}
      </span>
    </div>
  );
};

export default React.memo(ExternalDragOverlay);
